import CheckmarkBoxIconPath from "@ingka/ssr-icon/paths/checkmark-box";

export default CheckmarkBoxIconPath;
